import Vue from 'vue'

const state = {
    login: [],
    clients: [],
    register: [],
    languages: [],
    params_loaded: false,
    attempts: 0,
    user_profile: []
}

const actions = {
    SET_PARAMS(context, [login, clients, register, languages, attempts, user_profile]) {
        context.commit('SAVE_PARAMS', [login, clients, register, languages, attempts, user_profile])
    },

    SET_PARAMS_LOADED(context, [params_loaded]) {
        context.commit('SAVE_PARAMS_LOADED', [params_loaded])
    },

    SET_ATTEMPTS(context, [attempts]) {
        context.commit('SAVE_ATTEMPTS', [attempts])
    },
}

const mutations = {
    SAVE_PARAMS: (state, [login, clients, register, languages, attempts, user_profile]) => {
        Vue.set(state, 'login', login)
        Vue.set(state, 'clients', clients)
        Vue.set(state, 'register', register)
        Vue.set(state, 'languages', languages)
        Vue.set(state, 'attempts', attempts)
        Vue.set(state, 'user_profile', user_profile)
    },

    SAVE_PARAMS_LOADED: (state, [params_loaded]) => {
        Vue.set(state, 'params_loaded', params_loaded)
    },

    SAVE_ATTEMPTS: (state, [attempts]) => {
        Vue.set(state, 'attempts', attempts)
    }
}

const getters = {
    tmp_system_new_version: state => {
        return state.login.tmp_system_new_version
    },

    login_colors: state => {
        return state.login.colors
    },

    login_background: state => {
        return state.login.background
    },

    login_logo: state => {
        return state.login.logo
    },

    login_text_header: state => {
        return state.login.text_header
    },

    login_text: state => {
        return state.login.text
    },

    login_user_pre_register: state => {
        return state.login.user_pre_register
    },

    login_user_register: state => {
        return state.login.user_register
    },

    login_use_background: state => {
        return state.login.use_background
    },

    login_full_background: state => {
        return state.login.full_background
    },

    login_app_version: state => {
        return state.login.app_version
    },

    login_oauth2: state => {
        return state.login.oauth2
    },

    login_recaptcha: state => {
        return state.login.use_recaptcha
    },

    login_under_maintenance: state => {
        return state.login.under_maintenance
    },

    login_default_language_id: state => {
        return state.login.default_language_id
    },

    login_accept_document: state => {
        return state.login.accept_document
    },

    login_background_color: state => {
        return state.login.background_color
    },

    login_font_color: state => {
        return state.login.font_color
    },

    login_zendesk_help: state => {
        return state.login.use_zendesk_help
    },

    login_use_portfolio_page: state => {
        return state.login.use_portfolio_page
    },

    login_show_public_faq: state => {
        return state.login.show_public_faq
    },

    clients: state => {
        return state.clients
    },

    register: state => {
        return state.register
    },

    register_fields: state => {
        return state.register.fields ? state.register.fields : []
    },

    password_strong_level: state => {
        return state.register.password_strong_level
    },

    languages: state => {
        return state.languages
    },

    attempts: state => {
        return state.attempts
    },

    params_loaded: state => {
        return state.params_loaded
    },

    user_profile: state => {
        return state.user_profile
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
